import React, { useEffect, useRef, useState } from "react";

export default function SearchableSelect({
  options = [],
  value,
  onChange,
  placeholder = "Seleccionar…",
  disabled = false,
}) {
  const [query,   setQuery]   = useState("");
  const [open,    setOpen]    = useState(false);
  const [hovered, setHovered] = useState(null);
  const containerRef = useRef(null);
  const inputRef     = useRef(null);

  const selected = options.find((o) => o.value === value);
  const filtered  = options.filter((o) =>
    o.label.toLowerCase().includes(query.toLowerCase())
  );

  useEffect(() => {
    function onOutside(e) {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
        setQuery("");
      }
    }
    document.addEventListener("mousedown", onOutside);
    return () => document.removeEventListener("mousedown", onOutside);
  }, []);

  const openDropdown = () => {
    if (disabled) return;
    setQuery("");
    setOpen(true);
    setTimeout(() => inputRef.current?.focus(), 0);
  };

  const pick = (option) => {
    onChange(option.value);
    setOpen(false);
    setQuery("");
    setHovered(null);
  };

  const clear = (e) => {
    e.stopPropagation();
    onChange("");
    setOpen(false);
    setQuery("");
  };

  return (
    <div ref={containerRef} style={s.wrap}>
      <div
        style={{ ...s.control, ...(open ? s.controlOpen : {}), ...(disabled ? s.controlDisabled : {}) }}
        onClick={openDropdown}
      >
        {open ? (
          <input
            ref={inputRef}
            style={s.input}
            value={query}
            placeholder="Pesquisar…"
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Escape") { setOpen(false); setQuery(""); }
            }}
            onClick={(e) => e.stopPropagation()}
          />
        ) : (
          <span style={selected ? s.selectedLabel : s.placeholderText}>
            {selected ? selected.label : placeholder}
          </span>
        )}
        <div style={s.icons}>
          {value && !disabled && (
            <span style={s.clearBtn} onClick={clear}>×</span>
          )}
          <span style={{ ...s.arrow, ...(open ? s.arrowOpen : {}) }}>▾</span>
        </div>
      </div>

      {open && (
        <ul style={s.dropdown}>
          {filtered.length === 0 ? (
            <li style={s.noResults}>Sem resultados</li>
          ) : (
            filtered.map((o, i) => (
              <React.Fragment key={o.value}>
                {o.group && o.group !== filtered[i - 1]?.group && (
                  <li style={s.groupHeader}>{o.group}</li>
                )}
                <li
                  style={{
                    ...s.option,
                    ...(o.value === value   ? s.optionActive : {}),
                    ...(hovered === o.value && o.value !== value ? s.optionHover : {}),
                  }}
                  onMouseDown={() => pick(o)}
                  onMouseEnter={() => setHovered(o.value)}
                  onMouseLeave={() => setHovered(null)}
                >
                  {o.label}
                </li>
              </React.Fragment>
            ))
          )}
        </ul>
      )}
    </div>
  );
}

const s = {
  wrap: { position: "relative", width: "100%", maxWidth: 400 },

  control: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "10px 14px", border: "1px solid #cbd5e1", borderRadius: 6,
    fontSize: 15, backgroundColor: "#fff", color: "#1e293b", cursor: "pointer",
    minHeight: 42, gap: 8, boxSizing: "border-box",
  },
  controlOpen:     { borderColor: "#6366f1", boxShadow: "0 0 0 3px rgba(99,102,241,.12)" },
  controlDisabled: { backgroundColor: "#f8fafc", cursor: "not-allowed", opacity: 0.6 },

  input: {
    flex: 1, border: "none", outline: "none", fontSize: 15,
    color: "#1e293b", background: "transparent", padding: 0, minWidth: 0,
  },
  selectedLabel:  { flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },
  placeholderText:{ flex: 1, color: "#94a3b8", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" },

  icons:    { display: "flex", alignItems: "center", gap: 4, flexShrink: 0 },
  clearBtn: { color: "#94a3b8", cursor: "pointer", fontSize: 18, lineHeight: 1, padding: "0 2px", userSelect: "none" },
  arrow:    { color: "#64748b", fontSize: 12, transition: "transform 0.15s", userSelect: "none", lineHeight: 1 },
  arrowOpen:{ transform: "rotate(180deg)" },

  dropdown: {
    position: "absolute", top: "calc(100% + 4px)", left: 0, right: 0,
    background: "#fff", border: "1px solid #e2e8f0", borderRadius: 6,
    boxShadow: "0 4px 12px rgba(0,0,0,.10)", zIndex: 100,
    maxHeight: 240, overflowY: "auto",
    margin: 0, padding: "4px 0", listStyle: "none",
  },
  groupHeader:  { padding: "8px 14px 4px", fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.5 },
  option:       { padding: "9px 14px", cursor: "pointer", fontSize: 14, color: "#374151" },
  optionActive: { backgroundColor: "#eef2ff", color: "#4338ca", fontWeight: 500 },
  optionHover:  { backgroundColor: "#f8fafc" },
  noResults:    { padding: "10px 14px", color: "#94a3b8", fontSize: 14 },
};
